<template>
  <ValidationProvider rules="required">
    <FileUpload
      :isLoading="isRemovingFile"
      class="mt-5"
      :uploadingUrl="getAddFileUrl()"
      @unselectFile="unselectFile"
      @selectFile="selectFile"
      :files="files"
      v-model="files"
      :fileTypes="['application/pdf']"
      disableAutoProceed
      customActions
      :showValidationErrors="!files.length && showValidationErrors"
    />
  </ValidationProvider>
</template>

<script>
import FileUpload from "@/components/common/FileUpload";
import { ValidationProvider } from "vee-validate";
import { filter, forEach } from "lodash";
import APIService from "@/services/APIService";

export default {
  props: {
    question: {
      type: Object,
      required: true
    },
    showValidationErrors: Boolean
  },
  components: {
    FileUpload,
    ValidationProvider
  },
  created() {
    if (this.question.answerData) {
      this.files = this.question.answerData.attachments || [];
    }
  },
  data() {
    return {
      files: [],
      uppyInstance: null,
      isRemovingFile: false
    };
  },
  methods: {
    selectFile({ uppyInstance, file }) {
      this.uppyInstance = uppyInstance;
      this.files.push(file);
      this.$emit("onChange", {
        files: this.files,
        question: {
          type: "booking-application-questions",
          id: this.question.id
        }
      });
    },
    unselectFile({ uppyInstance, file }) {
      this.removeFile(file);
      uppyInstance.reset();
    },
    async removeFile(fileToBeRemoved) {
      if (fileToBeRemoved.url) {
        try {
          this.isRemovingFile = true;
          await APIService.client().delete(fileToBeRemoved.url);
        } catch (e) {
          console.error(e);
        } finally {
          this.isRemovingFile = false;
        }
      }
      this.files = filter(
        this.files,
        file => toString(file.id) === fileToBeRemoved.id
      );
    },
    async uploadFiles(answerId) {
      forEach(this.files, ({ id }) => this.setFileUrl(answerId, id));
      return this.uppyInstance && this.uppyInstance.upload(answerId);
    },
    async setFileUrl(answerId, fileId) {
      return this.uppyInstance.setFileState(fileId, {
        xhrUpload: { endpoint: this.getAddFileUrl(answerId) }
      });
    },
    getAddFileUrl(answerId) {
      const host = APIService.host;
      return `${host}/booking-application-question-answers/${answerId}/file`;
    }
  }
};
</script>

<style lang="scss" scoped></style>
